import request from '@/utils/request'
// 课程详情
export function coursedetails(data) {
    return request({
        url: 'business/course/' + data,
        method: 'get',
    })
}
// 公开课详情
export function openclassget(id) {
    return request({
        url: 'business/publicCourse/webList?pageNum=1&pageSize=100&id=' + id,
        method: 'post'
    })
}
// 课程目录学习进度
export function chapterStudyRecord(params) {
    return request({
        url: 'business/studyRecord/chapterStudyRecord',
        method: 'get',
        params,
    })
}
// 根据章节id获取视频资源
export function getPlayUrlByChapterId(params) {
    return request({
        url: 'vod/getPlayUrlByChapterId',
        method: 'get',
        params,
    })
}
// 根据视频id获取视频url
export function getPlayUrl(params) {
    return request({
        url: 'vod/getPlayUrl',
        method: 'get',
        params,
    })
}
//查询上一次播放的记录
export function lastRecord(params) {
    return request({
        url: 'business/studyRecord/lastRecord',
        method: 'get',
        params,
    })
}
// 记录播放记录
export function studyRecord(data) {
    return request({
        url: 'business/studyRecord',
        method: 'post',
        data,
    })
}
// 查询是否报名
export function uncertainEdlist(params) {
    return request({
        url: 'business/signup/hasSignup',
        method: 'get',
        params,
    })
}
// 报名
export function enlisup(data) {
    return request({
        url: 'business/signup',
        method: 'post',
        data,
    })
}
// 上传人脸图片
export function uploadR(data) {
    return request({
        url: 'upload/uploadBaseRenlian',
        method: 'post',
        data,
        header: {
            "Content-Type": 'application/x-www-form-urlencoded'
        }
    })
}
// 人脸对比
export function facelive(params) {
    return request({
        url: 'ai/live',
        method: 'get',
        params
    })
}
// 查看是否可以观看
export function lookstatus(params) {
    return request({
        url: 'business/chapter/canlook',
        method: 'get',
        params
    })
}
//试题请求
export function examget(params) {
    return request({
        url: 'business/chapterQu/list',
        method: 'get',
        params
    })
}
export function examdetailget(params) {
    return request({
        url: 'exam/qu/getQuInfo',
        method: 'get',
        params
    })
}
// 添加评论
export function addcomment(data) {
    return request({
        url: 'business/comment',
        method: 'post',
        data,
    })
}
//获取评论数据
export function getcomment(data) {
    return request({
        url: 'business/comment/webList?chapterId=' + data.chapterId + "&traineeId=" + data.traineeId + '&pageNum=' + data.pageNum + '&pageSize=' + data.pageSize,
        method: 'post',

    })
}
//删除评论
export function delinterar(data) {
    return request({
        url: 'business/comment/' + data,
        method: 'delete',

    })
}
//请求二维码
export function QRcode(params) {
    return request({
        url: 'business/chapter/applyQr',
        method: 'get',
        params
    })
}
//查询二维码扫描结果
export function qrcoderes(params) {
    return request({
        url: 'business/chapter/checkQr',
        method: 'get',
        params
    })
}
//弹框记录
export function tankhisry(data) {
    return request({
        url: 'business/faceRecord',
        method: 'post',
        data
    })
}

//查看弹框位置
export function tanktimes(params) {
    return request({
        url: 'business/chapter/getTankuangVos',
        method: 'get',
        params
    })
}
// 添加咨询信息
export function zixunpost(data) {
    return request({
        url: 'business/consult',
        method: 'post',
        data
    })
}

// 搜索
export function listCourseByTitle(title) {
    return request({
        url: 'business/course/listCourseByTitle',
        method: 'get',
        params: {
            title
        }
    })
}

// 判断是否进行各种识别
export function otherFunction() {
    return request({
        url: 'business/other/function',
        method: 'get'
    })
}

// 课程树形列
export function getLabelList(params) {
    return request({
        url: 'business/label/listTeacherAndMine',
        method: 'get',
        params
    })
}

//上传视频和书签位置
export function getScreenshot(query){
    return request({
        url: 'upload/getScreenshot',
        method: 'get',
        params: query
    })
}
// 添加标签
export function addmark(data){
    return request({
        url: 'business/label',
        method: 'post',
        data
    })
}
// 修改
export function updatemark(data){
    return request({
        url: 'business/label',
        method: 'put',
        data
    })
}
// 删除
export function delProfession(id){
return request({
    url: 'business/label/'+id,
    method: 'delete',
})
}
//课签截图上传
export function kqpostimg(data){
    return request({
        url: 'upload/uploadOther',
        method: 'post',
        data
    })
}